import { CommentLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

export const EmptyPlaceholder: React.FC = () => (
  <div className={css.empty_placeholder}>
    <CommentLight className={css.icon} />
    <span className={css.message}>
      No comments yet. Click anywhere on the board to leave one
    </span>
  </div>
)
